module.exports = __webpack_public_path__ + "static/media/andy.ea9ae71a.jpg";